import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { resolveHighHandPage } from "src/utils/highHandUtils";
import { isMeaningfulHighHandPage } from "src/utils/mapHighHand";
import Page404 from "src/pages/Page404";
import HighHandPageContent from "src/pages/promotions/poker/highHand/HighHandPageContent";

/**
 * Dynamic High Hand LP — Payload when `high-hand` is in REACT_APP_PAYLOAD_SOURCES,
 * otherwise (or on Payload failure / empty doc) JSON locales via getHighHandData.
 */
const HighHandMain = () => {
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const [page, setPage] = useState(null);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      setIsNotFound(false);
      try {
        const resolved = await resolveHighHandPage(location, i18n.language);
        if (cancelled) return;
        if (isMeaningfulHighHandPage(resolved)) {
          setPage(resolved);
        } else {
          setPage(null);
          setIsNotFound(true);
        }
      } catch (error) {
        console.error("Failed to load high hand content:", error);
        if (!cancelled) {
          setPage(null);
          setIsNotFound(true);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [location.pathname, i18n.language]);

  if (isLoading) {
    return (
      <LoadingStatus>
        <Spinner animation="border" variant="light" role="status">
          <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </LoadingStatus>
    );
  }
  if (isNotFound || !page) return <Page404 />;

  return <HighHandPageContent page={page} />;
};

const LoadingStatus = styled.div`
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--black);
`;

export default HighHandMain;
